import { render, staticRenderFns } from "./TwoColumnLayout.vue?vue&type=template&id=a4012914&"
import script from "./TwoColumnLayout.ts?vue&type=script&lang=ts&"
export * from "./TwoColumnLayout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports